/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Voice_Manager_Preview_LabelInputs */



/**
* | output |
* | --- |
* | "Preview {name}" |
*
* @param {Voice_Manager_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_preview_label = /** @type {((inputs: Voice_Manager_Preview_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Preview_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Apercu ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Vorschau ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Anteprima ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предварительный просмотр ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Vista previa ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`预览 ${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プレビュー ${i?.name}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पूर्वावलोकन ${i?.name}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Pré-visualização ${i?.name}`)
	return /** @type {LocalizedString} */ (`Preview ${i?.name}`)
});